import { render, staticRenderFns } from "./EditSocialIconsTabLayout.vue?vue&type=template&id=de74ecb6&scoped=true&"
import script from "./EditSocialIconsTabLayout.vue?vue&type=script&lang=js&"
export * from "./EditSocialIconsTabLayout.vue?vue&type=script&lang=js&"
import style0 from "./EditSocialIconsTabLayout.vue?vue&type=style&index=0&id=de74ecb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de74ecb6",
  null
  
)

export default component.exports